import { render, staticRenderFns } from "./relatorios-Stock.vue?vue&type=template&id=19c7f744&"
import script from "./relatorios-Stock.vue?vue&type=script&lang=js&"
export * from "./relatorios-Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports